export const RECOMMENDATION_TYPES = {
  DYNAMIC: 1,
  STATIC: 2,
  DEFAULT: 3,
};
